import React, { useEffect, useRef } from 'react'
// AntV G2Plot
import { Gauge } from '@antv/g2plot';
// i18
import { useTranslation } from 'react-i18next'

export const Range = ({ graph }) => {
    const { t } = useTranslation(["translation"]);
    const chartRef = useRef(null);

    const getRandomColor = () => {
        return `#${Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0')}`;
    };

    useEffect(() => {
        const data = [];

        if (graph === null) {
            data.push(
                { name: `${t("ex")} 1`, value: 100 },
                { name: `${t("ex")} 2`, value: 120 }
            );
        }
        else if (graph.channel) {
            const campos = graph.fields[graph.channel];
            campos.forEach(element => {
                data.push({ name: element.name, value: element.value });
            });
        }
        else {
            const campos = graph.fields;
            campos.forEach(element => {
                data.push({ name: element.name, value: element.value });
            });
        }

        const totalValue = data.reduce((acc, item) => acc + item.value, 0);
        const porcentSub = totalValue / data.length;
        const porcentTotal = porcentSub * 0.01;

        let accumulated = 0;
        const ticks = data.map((item) => {
            accumulated += item.value;
            return accumulated / totalValue;
        });

        const rangeColors = data.map(() => getRandomColor());

        const gauge = new Gauge(chartRef.current, {
            percent: porcentTotal,
            min: 0,
            max: 1,
            range: {
                ticks: [0, ...ticks],
                color: rangeColors,
            },
            indicator: {
                pointer: {
                    style: {
                        stroke: '#D0D0D0',
                    },
                },
                pin: {
                    style: {
                        stroke: '#D0D0D0',
                    },
                },
            },
            statistic: {
                content: {
                    formatter: () => `Total ${totalValue.toFixed(2)}`,
                    style: {
                        fontSize: '28px',
                        lineHeight: '28px',
                    },
                },
            },
            axis: {
                label: {
                    formatter: (value) => {
                        const index = ticks.findIndex((tick, i) => {
                            const prev = i === 0 ? 0 : ticks[i - 1];
                            return value > prev && value <= tick;
                        });
                        return data[index]?.name || '';
                    },
                    style: {
                        fontSize: 12,
                        fill: '#000',
                    },
                    autoHide: true,
                    autoRotate: true,
                    offset: -45,
                },
            },
        });

        gauge.render();

        return () => gauge.destroy();
    }, [graph, t]);

    return <div ref={chartRef} style={{ width: "80%", height: "80%" }} />;
};
